import React, {
  createContext,
  useContext,
  useState,
  ReactNode
} from "react";

export interface LoadingContextValue {
  show: () => void;
  hide: () => void;
  loading: boolean;
}

const LoadingContext = createContext<LoadingContextValue | undefined>(
  undefined
);

export const useLoading = (): LoadingContextValue => {
  const ctx = useContext(LoadingContext);
  if (!ctx) {
    throw new Error("useLoading must be used within LoadingProvider");
  }
  return ctx;
};

interface LoadingProviderProps {
  children: ReactNode;
}

export const LoadingProvider: React.FC<LoadingProviderProps> = ({
  children
}) => {
  const [count, setCount] = useState<number>(0);

  const show = () => setCount(c => c + 1);
  const hide = () => setCount(c => Math.max(0, c - 1));

  return (
    <LoadingContext.Provider
      value={{ show, hide, loading: count > 0 }}
    >
      {children}
    </LoadingContext.Provider>
  );
};
